const INIT_STATE = {
   newsletterContent: [],
   templateId: "",
   templateName: "",
   coverPhotoURL: "",
   templateSubject: "",
   templateContent: "",
   templateSubscribers: [],
   templateSaveable: false,
   templateIsNew: false,
   templateNewsletter: { name: "", id: null },
   isFileAdded: false,
   csv: null
};
const newsletter = (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_TEMPLATE_ID": {
         return {
            ...state,
            templateName: action.templateId
         };
      }
      case "SET_TEMPLATE_NAME": {
         return {
            ...state,
            templateName: action.templateName
         };
      }
      case "SET_TEMPLATE_COVER": {
         return {
            ...state,
            coverPhotoURL: action.coverPhotoURL
         };
      }
      case "SET_TEMPLATE_SUBJECT": {
         return {
            ...state,
            templateSubject: action.templateSubject
         };
      }
      case "SET_IS_FILE_ADDED": {
         return {
            ...state,
            isFileAdded: action.isFileAdded
         };
      }
      case "SET_TEMPLATE_CONTENT": {
         return {
            ...state,
            templateContent: action.templateContent
         };
      }
      case "SET_TEMPLATE_SUBSCRIBERS": {
         return {
            ...state,
            templateSubscribers: action.templateSubscribers
         };
      }
      case "SET_TEMPLATE_SAVEABLE": {
         return {
            ...state,
            templateSaveable: action.templateSaveable
         };
      }
      case "SET_TEMPLATE_IS_NEW": {
         return {
            ...state,
            templateIsNew: action.templateIsNew
         };
      }
      case "SET_TEMPLATE_NEWSLETTER": {
         return {
            ...state,
            templateNewsletter: action.templateNewsletter
         };
      }
      case "SET_NEWSLETTER_CSV": {
         return {
            ...state,
            csv: action.csv
         };
      }
      case "SET_NEWSLETTER_CONTENT": {
         if (action.newsletterContent === undefined || action.newsletterContent === null) return;
         let list = state.newsletterContent;
         let contains = false;
         if (state.newsletterContent) {
            state.newsletterContent.forEach((element, i) => {
               if (element.wId === action.newsletterContent.wId) {
                  let content = action.newsletterContent;
                  let obj = {
                     wId: content.wId ? content.wId : list[i].wId,
                     csv: content.csv || content.csv === null ? content.csv : list[i].csv,
                     subject:
                        content.subject || content.subject === ""
                           ? content.subject
                           : list[i].subject,
                     templateName:
                        content.templateName || content.templateName === ""
                           ? content.templateName
                           : list[i].templateName,
                     coverPhotoURL:
                        content.coverPhotoURL || content.coverPhotoURL === ""
                           ? content.coverPhotoURL
                           : list[i].coverPhotoURL,
                     templateId:
                        content.templateId || content.templateId === null
                           ? content.templateId
                           : list[i].templateId,
                     content:
                        content.content || content.content === ""
                           ? content.content
                           : list[i].content,
                     newsletterName:
                        content.newsletterName || content.newsletterName === ""
                           ? content.newsletterName
                           : list[i].newsletterName,
                     newsletterId:
                        content.newsletterId || content.newsletterId === null
                           ? content.newsletterId
                           : list[i].newsletterId,
                     subscribers:
                        content.subscribers || content.subscribers === null
                           ? content.subscribers
                           : list[i].subscribers
                  };
                  if (content.csv === null) {
                     obj.csv = null;
                  }
                  if (content.coverPhotoURL === null) {
                     obj.coverPhotoURL = null;
                  }
                  if (content.subscribers === null) {
                     obj.subscribers = null;
                  }
                  list[i] = obj;
                  contains = true;
               }
            });
         } else {
            list = [];
         }
         if (!contains) {
            list.push(action.newsletterContent);
         }
         return {
            ...state,
            newsletterContent: list
         };
      }
      default:
         return state;
   }
};

export default newsletter;
